import { render } from "./Providers.vue?vue&type=template&id=a51fd6e0"
import script from "./Providers.vue?vue&type=script&lang=js"
export * from "./Providers.vue?vue&type=script&lang=js"
script.render = render
/* hot reload */
if (module.hot) {
  script.__hmrId = "a51fd6e0"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('a51fd6e0', script)) {
    api.reload('a51fd6e0', script)
  }
  
  module.hot.accept("./Providers.vue?vue&type=template&id=a51fd6e0", () => {
    api.rerender('a51fd6e0', render)
  })

}

script.__file = "resources/js/Pages/User/Partials/Providers.vue"

export default script